import { render, staticRenderFns } from "./LogDiff.vue?vue&type=template&id=88a897d6&"
import script from "./LogDiff.vue?vue&type=script&lang=js&"
export * from "./LogDiff.vue?vue&type=script&lang=js&"
import style0 from "./LogDiff.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports